import * as React from 'react';
import styled from 'styled-components';
import { Text, theme, Title, Divider } from 'components';
import { PriceMap } from 'api/get';

type PricingInfoProps = {
  priceMap: PriceMap;
};

const PricingInfo: React.FC<PricingInfoProps> = ({ priceMap }) => {
  const {
    perAgentPrice,
    monthlyPrice,
    subTotal,
    hst,
    totalDue,
    globalTaxPercentage,
    billableUsersCount,
  } = priceMap;
  return (
    <div style={{ marginTop: '10px' }}>
      <div>
        <Text block strong>
          First Month&apos;s Payment
        </Text>
        <StyledPrice>
          <Text block>
            ${perAgentPrice.toFixed(2)} x {billableUsersCount}{' '}
            {billableUsersCount === 1 ? 'agent' : 'agents'}
          </Text>
          <Text block data-cy="monthly-price">
            ${monthlyPrice.toFixed(2)}
          </Text>
        </StyledPrice>
      </div>
      <Divider style={{ margin: '5px 0px' }} />
      <StyledPrice>
        <Text block style={{ color: theme.gray8 }}>
          Subtotal
        </Text>
        <Text block data-cy="subtotal-price">
          ${subTotal.toFixed(2)}
        </Text>
      </StyledPrice>
      <StyledPrice>
        <Text block style={{ color: theme.gray8 }}>
          Sales Tax {globalTaxPercentage}%
        </Text>
        <Text block data-cy="calculated-hst">
          ${hst.toFixed(2)}
        </Text>
      </StyledPrice>
      <StyledPrice>
        <Text block style={{ color: theme.gray8 }}>
          Total Due:
        </Text>
        <Title level={2} style={{ margin: 0 }} data-cy="total-due-price">
          ${totalDue.toFixed(2)}
        </Title>
      </StyledPrice>
    </div>
  );
};

export default PricingInfo;

const StyledPrice = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0px 2px 0px;
`;
